<template>
  <div class="data-list">
    <div
      v-for="(item, index) in data"
      :key="index"
      class="data-list__item"
    >
      <h5 class="data-list__title">
        {{ item.title }}
      </h5>
      <span v-if="item.desc.indexOf(',') !== -1">
        <span
          v-for="i in item.desc.split(',')"
          :key="i"
          class="data-list__desc"
        >
          {{ i }}
        </span>
      </span>
      <span v-else>
        {{ item.desc }}
      </span>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      data: {
        type: Array,
        default: () => []
      }
    }
  };
</script>
<style lang="scss">
  @import "../../styles/shared/shared";

  .data-list {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 1rem;
    &__item {
      margin-bottom: .5rem;
      flex: 0 0 50%;
      max-width: 50%;
      padding-right: .5em;
      @include minpoint(tablet) {
        flex-basis: 33.3333333333%;
        max-width: 33.3333333333%;
      }
    }
    &__desc {
      display: block;
    }
    &__title {
      margin-bottom: 0;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    &__desc {
      word-break: break-word;
    }
  }
</style>
